import React from "react"
import EngineIDNavBar from "@components/EngineIDNavBar"
import BannerDemo from "./BannerDemo"
import DemoSection from "./DemoSection"
import CTASignUpLong from "@components/CTASignUpLong"
import Footer from "@components/Footer"
import "@styles/global.scss"
import "@styles/custom-bootstrap.scss"

const Demo = props => {
  return (
    <div>
      <EngineIDNavBar />
      <BannerDemo />
      <div className={"container-fluid"}>
        <div className={"maxWidth"}>
          <DemoSection></DemoSection>
        </div>
      </div>
      <CTASignUpLong />
      <Footer />
    </div>
  )
}

export default Demo
